import { combineReducers } from 'redux';
import adminReducer, { AdminStoreState } from './admin';
import menteeReducer, { MenteeStoreState } from './mentee';
import mentorReducer, { MentorStoreState } from './mentor';

export type StoreState = {
  admin: AdminStoreState;
  mentor: MentorStoreState;
  mentee: MenteeStoreState;
};

const rootReducer = combineReducers({
  admin: adminReducer,
  mentor: mentorReducer,
  mentee: menteeReducer,
});

export default rootReducer;
